// Asset imports
import logoLapedia from "../assets/logoLapedia.png";
import logoLapediaEON from "../assets/eon/logoLapediaEON.png";
import logoGrayScaleSvg from "../assets/logoGrayScaleSvg.svg";
import logoGrayScaleSvgEON from "../assets/eon/logoGrayScaleSvgEON.svg";
import search from "../assets/search.svg";
import searchEON from "../assets/eon/searchEON.svg";
import searchBro from "../assets/search-bro.svg";
import search_broEON from "../assets/eon/search-broEON.svg";
import arrow from "../assets/arrow.svg";
import arrowEON from "../assets/eon/arrowEON.svg";
import author from "../assets/author.svg";
import authorEON from "../assets/eon/authorEON.svg";
import space from "../assets/space.svg";
import spaceEON from "../assets/eon/spaceEON.svg";
import evaluate from "../assets/evaluate.svg";
import evaluateEON from "../assets/eon/evaluateEON.svg";
import laptop from "../assets/laptop.svg";
import laptopEON from "../assets/eon/laptopEON.svg";
import notFoundIllustration from "../assets/notFoundIllustration.svg";
import notFoundIllustrationEON from "../assets/eon/notFoundIllustrationEON.svg";
import maintenanceIllustration from "../assets/maintenanceIllustration.svg";
import maintenanceIllustrationEON from "../assets/eon/maintenanceIllustrationEON.svg";
import illustration from "../assets/illustration.svg";
import illustrationEON from "../assets/eon/illustrationEON.svg";
import backgroundAbout from "../assets/background_about.svg";
import backgroundAboutEON from "../assets/eon/background_aboutEON.svg";
import backgroundNoMatch from "../assets/background_noMatch_blue.svg";
import backgroundNoMatchEON from "../assets/eon/background_noMatch_blueEON.svg";

export type ThemePalette = {
  master: string;
  masterLight: string;
  masterHover: string;
  second: string;
  secondLight: string;
  secondHover: string;
  accent: string;
  accentHover: string;
  danger: string;
  dangerHover: string;
  success: string;
  successHover: string;
  neutralStrong: string;
  neutral: string;
  neutralHover: string;
  neutralLight: string;
  surfaceSoft: string;
  surface: string;
  surfaceOverlay: string;
  shadow: string;
  shadowDark: string;
};

export type ThemeAssets = {
  logoLapedia: string;
  logoGrayScaleSvg: string;
  search: string;
  searchBro: string;
  arrow: string;
  author: string;
  space: string;
  evaluate: string;
  laptop: string;
  notFoundIllustration: string;
  maintenanceIllustration: string;
  illustration: string;
  aboutHeaderBackground: string;
  noMatchBackground: string;
};

export const COLOR_LAPEDIA_BNAVY = "#286385";
export const COLOR_LAPEDIA_BNAVY_LIGHT = "#d4e0e7";
export const COLOR_LAPEDIA_BNAVY_HOVER = "#53829d";
export const COLOR_LAPEDIA_BBLUE = "#3788b8";
export const COLOR_LAPEDIA_BBLUE_LIGHT = "#d7e7f1";
export const COLOR_LAPEDIA_BBLUE_HOVER = "#5fa0c6";
export const COLOR_LAPEDIA_BYELLOW = "#ffc933";
export const COLOR_LAPEDIA_BYELLOW_HOVER = "#ffd45c";
export const COLOR_LAPEDIA_BRED = "#db4a21";
export const COLOR_LAPEDIA_BRED_HOVER = "#e26e4d";
export const COLOR_LAPEDIA_BGREEN = "#4caf50";
export const COLOR_LAPEDIA_BGREEN_HOVER = "#43a047";
export const COLOR_LAPEDIA_BDARKGRAY = "#353535";
export const COLOR_LAPEDIA_BMEDIUMGRAY = "#969696";
export const COLOR_LAPEDIA_BMEDIUMGRAY_HOVER = "#7f7f7f";
export const COLOR_LAPEDIA_BLIGHTGRAY = "#e6e6e6";
export const COLOR_LAPEDIA_BEXTRALIGHTGRAY = "#fafafa";
export const COLOR_LAPEDIA_BWHITE = "#ffffff";
export const COLOR_LAPEDIA_BWHITE_OVERLAY = "rgba(255, 255, 255, 0.97)";
export const COLOR_LAPEDIA_SHADOW = "0px 4px 20px 0px rgba(0, 0, 0, 0.04)";
export const COLOR_LAPEDIA_SHADOW_DARK =
  "0px 4px 11px 0px rgba(0, 0, 0, 0.1)";

export const COLOR_EON_MASTER = "#9D1207";
export const COLOR_EON_MASTER_LIGHT = "#9d110744";
export const COLOR_EON_MASTER_HOVER = "#9d1107ca";
export const COLOR_EON_SECOND = "#C73B24";
export const COLOR_EON_SECOND_LIGHT = "#C73B2444";
export const COLOR_EON_SECOND_HOVER = "#C73B24ca";
export const COLOR_EON_ACCENT = "#ffb6ae";
export const COLOR_EON_ACCENT_HOVER = "#ffb6aeca";
export const COLOR_EON_DANGER = "#89237E";
export const COLOR_EON_DANGER_HOVER = "#a23a9b";
export const COLOR_EON_SUCCESS = "#4c87af";
export const COLOR_EON_SUCCESS_HOVER = "#4c87af";
export const COLOR_EON_NEUTRAL_STRONG = "#353535";
export const COLOR_EON_NEUTRAL = "#969696";
export const COLOR_EON_NEUTRAL_HOVER = "#7f7f7f";
export const COLOR_EON_NEUTRAL_LIGHT = "#e6e6e6";
export const COLOR_EON_SURFACE_SOFT = "#fafafa";
export const COLOR_EON_SURFACE = "#ffffff";
export const COLOR_EON_SURFACE_OVERLAY = "rgba(255, 255, 255, 0.97)";
export const COLOR_EON_SHADOW = "0px 4px 20px 0px rgba(0, 0, 0, 0.04)";
export const COLOR_EON_SHADOW_DARK =
  "0px 4px 11px 0px rgba(0, 0, 0, 0.1)";

const DEFAULT_ASSETS: ThemeAssets = {
  logoLapedia,
  logoGrayScaleSvg,
  search,
  searchBro,
  arrow,
  author,
  space,
  evaluate,
  laptop,
  notFoundIllustration,
  maintenanceIllustration,
  illustration,
  aboutHeaderBackground: backgroundAbout,
  noMatchBackground: backgroundNoMatch,
};

const ALT_ASSETS: ThemeAssets = {
  logoLapedia: logoLapediaEON,
  logoGrayScaleSvg: logoGrayScaleSvgEON,
  search: searchEON,
  searchBro: search_broEON,
  arrow: arrowEON,
  author: authorEON,
  space: spaceEON,
  evaluate: evaluateEON,
  laptop: laptopEON,
  notFoundIllustration: notFoundIllustrationEON,
  maintenanceIllustration: maintenanceIllustrationEON,
  illustration: illustrationEON,
  aboutHeaderBackground: backgroundAboutEON,
  noMatchBackground: backgroundNoMatchEON,
};

const THEME_ASSETS: Record<string, ThemeAssets> = {
  default: DEFAULT_ASSETS,
  alt: ALT_ASSETS,
};
const DEFAULT_THEME: ThemePalette = {
  master: COLOR_LAPEDIA_BNAVY,
  masterLight: COLOR_LAPEDIA_BNAVY_LIGHT,
  masterHover: COLOR_LAPEDIA_BNAVY_HOVER,
  second: COLOR_LAPEDIA_BBLUE,
  secondLight: COLOR_LAPEDIA_BBLUE_LIGHT,
  secondHover: COLOR_LAPEDIA_BBLUE_HOVER,
  accent: COLOR_LAPEDIA_BYELLOW,
  accentHover: COLOR_LAPEDIA_BYELLOW_HOVER,
  danger: COLOR_LAPEDIA_BRED,
  dangerHover: COLOR_LAPEDIA_BRED_HOVER,
  success: COLOR_LAPEDIA_BGREEN,
  successHover: COLOR_LAPEDIA_BGREEN_HOVER,
  neutralStrong: COLOR_LAPEDIA_BDARKGRAY,
  neutral: COLOR_LAPEDIA_BMEDIUMGRAY,
  neutralHover: COLOR_LAPEDIA_BMEDIUMGRAY_HOVER,
  neutralLight: COLOR_LAPEDIA_BLIGHTGRAY,
  surfaceSoft: COLOR_LAPEDIA_BEXTRALIGHTGRAY,
  surface: COLOR_LAPEDIA_BWHITE,
  surfaceOverlay: COLOR_LAPEDIA_BWHITE_OVERLAY,
  shadow: COLOR_LAPEDIA_SHADOW,
  shadowDark: COLOR_LAPEDIA_SHADOW_DARK,
};

const ALT_THEME: ThemePalette = {
  master: COLOR_EON_MASTER,
  masterLight: COLOR_EON_MASTER_LIGHT,
  masterHover: COLOR_EON_MASTER_HOVER,
  second: COLOR_EON_SECOND,
  secondLight: COLOR_EON_SECOND_LIGHT,
  secondHover: COLOR_EON_SECOND_HOVER,
  accent: COLOR_EON_ACCENT,
  accentHover: COLOR_EON_ACCENT_HOVER,
  danger: COLOR_EON_DANGER,
  dangerHover: COLOR_EON_DANGER_HOVER,
  success: COLOR_EON_SUCCESS,
  successHover: COLOR_EON_SUCCESS_HOVER,
  neutralStrong: COLOR_EON_NEUTRAL_STRONG,
  neutral: COLOR_EON_NEUTRAL,
  neutralHover: COLOR_EON_NEUTRAL_HOVER,
  neutralLight: COLOR_EON_NEUTRAL_LIGHT,
  surfaceSoft: COLOR_EON_SURFACE_SOFT,
  surface: COLOR_EON_SURFACE,
  surfaceOverlay: COLOR_EON_SURFACE_OVERLAY,
  shadow: COLOR_EON_SHADOW,
  shadowDark: COLOR_EON_SHADOW_DARK,
};

const THEMES: Record<string, ThemePalette> = {
  default: DEFAULT_THEME,
  alt: ALT_THEME,
};

const resolveThemeName = (): string => {
  return (process.env.REACT_APP_THEME || "default").trim().toLowerCase();
};

export const selectedThemeName = resolveThemeName();
export const selectedTheme: ThemePalette =
  THEMES[selectedThemeName] || DEFAULT_THEME;
export const selectedAssets: ThemeAssets =
  THEME_ASSETS[selectedThemeName] || DEFAULT_ASSETS;

export const applySelectedTheme = (): void => {
  if (typeof document === "undefined") {
    return;
  }

  const themeName = THEMES[selectedThemeName] ? selectedThemeName : "default";
  const activeTheme = THEMES[themeName];

  document.documentElement.setAttribute("data-theme", themeName);

  (Object.entries(activeTheme) as Array<[keyof ThemePalette, string]>).forEach(
    ([key, value]) => {
      document.documentElement.style.setProperty(`--${key}`, value);
    },
  );

  document.documentElement.style.setProperty(
    "--about-header-background",
    `url("${selectedAssets.aboutHeaderBackground}")`,
  );
  document.documentElement.style.setProperty(
    "--no-match-background",
    `url("${selectedAssets.noMatchBackground}")`,
  );
};